// 导入封装好的axios实例
import request from '@/utils/request';
import { turnTimestamp } from '@/utils/utils';
const BASE_URL = '/h5/hro';
const api =  {
	Login: '/portal/login',
	Logout : '/portal/logout',
	GetProjectList : '/project/availableProjectList',
	GetEmInfo: '/portal/employeeInfoByProjectId',
  }

// 获取当前时间的一个时间戳
const nowTurnTimestamp = () =>{
	const nowDate = new Date;
	return turnTimestamp(nowDate);
}
const requestId = nowTurnTimestamp(); // 登录所需时间戳
/**
 * login 登录
 * 
 */
// 雇员登录的接口
export const login = (data) => {
return request({
url: `${BASE_URL}${api.Login}`,
method: 'post',
data: {...data, requestId}
});
};

// 获取可用项目列表
export const getProjectList = () => {
	return request({
	url: `${BASE_URL}${api.GetProjectList}`,
	method: 'get',
	});
  };

// 雇员登录后的个人信息
export const getEmInfo = (projectId) => {
	return request({
	url: `${BASE_URL}${api.GetEmInfo}/${projectId}`,
	method: 'GET',
	});
  };

  // 生成或短或长的UUID
export const getUuid = () => {
	return request({
	url: api.Uuid,
	method: 'get',
	});
  };
  // 用户调用此接口后token失效
export const logout = () => {
	return request({
	url: `${BASE_URL}${api.Logout}`,
	method: 'delete',
	});
  };
